export const messages = Object.freeze({
    afs_migrating: 'This file share is being migrated. Please try again later.',
    aid_is_none: 'A required application value is missing from the request.',
    aid_not_found: 'The requested application could not be found.',
    aid_session_invalid: 'Invalid application session. Please check your input and try again.',
    ambiguous_configuration_provided: 'Ambiguous configuration provided. Please be more specific.',
    app_already_started_in_shared_mode: 'This application is already running in shared mode. Open the existing session instead.',
    app_missing: 'The application is missing or could not be found.',
    app_not_found: 'The requested application could not be found.',
    app_not_shared: 'The application is not shared.',
    app_update_unique_constraint_violation: 'An application with these settings already exists.',
    application_session_finished: 'This application session has already ended.',
    cannot_run_app_shared_with_image_shared_mode_never: 'Cannot run application shared with image shared mode never.',
    conflicting_handback_mount_request: 'A conflicting hand-back request is already in progress.',
    conid_is_none: 'A required value is missing. Refresh the page and try again.',
    container_not_found: 'The requested container could not be found.',
    deleted_app_lineage: 'This application has been deleted.',
    docker_export_error: 'The image export could not be completed. Please try again or contact support.',
    dockerhub_login_error: 'Could not sign in to the image registry. Please try again or contact support.',
    exclusion_missing: 'The exclusion is missing or could not be found.',
    exclusion_not_found: 'The requested exclusion could not be found.',
    fileshare_name_missing: 'The fileshare name is missing or could not be found.',
    ignore_historical_activity_is_none: 'A required ignore historical activity value is missing from the request.',
    image_manager_role_already_exists: 'This image manager role already exists.',
    image_manager_role_missing: "You don't have permission to manage images.",
    image_manager_role_not_found: 'The requested image manager role could not be found.',
    image_missing: 'The image is missing or could not be found.',
    image_not_available_in_space: 'The image is not available in space.',
    image_not_exportable: 'The image is not exportable.',
    image_with_db_sidecar_not_always_shared: 'The application sharing mode is not supported with its Tables setting.',
    insufficient_credits_for_scaled_app: "There aren't enough credits to start this scaled application.",
    'Invalid user id!': 'Invalid user. Please log in again.',
    invalid_cpu_inactivity_limit: 'Invalid CPU inactivity limit. Please check your input and try again.',
    invalid_docker_url: 'Invalid image URL. Please check your input and try again.',
    invalid_hami_resource_limit_provided: 'The operation could not be completed. Please try again or contact support.',
    invalid_home_mount_type_provided: 'Invalid home mount type provided. Please check your input and try again.',
    invalid_inactivity_limit_provided: 'Invalid inactivity limit provided. Please check your input and try again.',
    invalid_ipc_mode: 'The operation could not be completed. Please try again or contact support.',
    invalid_log_limit: 'Invalid log limit. Please check your input and try again.',
    invalid_ncu_provided: 'Invalid NCU provided. Please check your input and try again.',
    invalid_node_pool_type: 'Invalid node pool type. Please check your input and try again.',
    invalid_nodepool: 'This machine type is not available for this space.',
    invalid_nodepool_resource: 'Invalid nodepool resource. Please check your input and try again.',
    invalid_nodepool_to_schedule_startup: 'Invalid nodepool to schedule startup. Please check your input and try again.',
    invalid_parameters: 'Invalid parameters. Please check your input.',
    invalid_rclone_mount_mount_path: 'The mount path is invalid. Choose a valid folder path and try again.',
    invalid_schedule_config: 'Invalid schedule config. Please check your input and try again.',
    invalid_session: 'Invalid session. Please check your input and try again.',
    invalid_sharepoint_mount_path: 'Invalid sharepoint mount path. Please check your input and try again.',
    invalid_space_credit_limit: 'This space has no valid credit limit for scaled applications.',
    invalid_space_type: 'Invalid space type. Please check your input and try again.',
    invalid_sshfs_mount_path: 'Invalid mount path. Please check your input and try again.',
    invalid_startup_schedule: 'Invalid startup schedule. Please check your input and try again.',
    link_missing: 'The link is missing or could not be found.',
    log_access_denied: "You don't have access to these logs.",
    log_store_connection_error: 'The log store connection operation failed. Please try again or contact support.',
    max_wait_iterations_reached: 'The maximum number of wait iterations has been reached.',
    missing_stop_after_minutes: 'Required stop after minutes is missing.',
    multiple_vpn_sidecars_not_supported: 'Only one VPN connection is supported per application.',
    no_deployments_found: 'No deployments was found.',
    no_dev_version_found: 'No dev version was found.',
    no_shared_mode_in_image_config: 'No shared mode in image config was found or provided.',
    no_sidecar_configured: 'The operation could not be completed. Please try again or contact support.',
    no_users_found: 'No matching users were found. Check the selected users or email addresses.',
    node_pool_cpu_limit_missing: 'The node pool CPU limit is missing or could not be found.',
    node_pool_memory_limit_missing: 'The node pool memory limit is missing or could not be found.',
    non_development_snapshot: 'This action is only allowed on the current state.',
    not_assignment: 'This is not an assignment.',
    not_bundle_space: "This space doesn't support assignments.",
    not_development_snapshot: 'This action is only allowed on the current state.',
    not_handin_instance: 'This is not a hand-in instance.',
    not_research_space: 'This is only available in research spaces.',
    opensearch_error: 'The search could not be completed. Please try again or contact support.',
    placeholder_deployment_missing: 'The placeholder deployment is missing or could not be found.',
    price_missing: 'The price is missing or could not be found.',
    scaling_not_enabled: 'Scaling is not enabled.',
    scheduled_app_missing: 'The scheduled application is missing or could not be found.',
    scheduled_startup_missing: 'The scheduled startup is missing or could not be found.',
    session_aid: 'This application session is invalid.',
    session_not_found: 'The requested session could not be found.',
    session_transaction_amount: 'The session transaction amount is invalid.',
    shared_mode_never_with_sidecar: "This sharing mode can't be used with this application setting.",
    shared_use_starter_secrets_must_be_set: 'Required secrets must be set for shared use.',
    sidecar_container_failed: 'The operation could not be completed. Please try again or contact support.',
    snapshot_name_missing: 'The snapshot name is missing or could not be found.',
    snapshot_of_app_is_deleting: "This application's snapshot is being deleted.",
    space_credit_limit_overage: 'The space credit limit has been reached.',
    ssid_is_none: 'A required value is missing. Refresh the page and try again.',
    startup_in_past: 'The scheduled start time must be in the future.',
    stop_after_minutes_missing: 'The stop after minutes is missing or could not be found.',
    stop_after_minutes_too_large: 'The automatic stop time is too long.',
    stop_after_minutes_too_small: 'The automatic stop time is too short.',
    tenant_cephfs_lfs_unavailable: 'The integration file storage operation could not be completed. Please contact support.',
    tenant_cluster_locked: 'An operation is already running for this integration. Wait for it to finish and try again.',
    tenant_cluster_missing: 'The tenant cluster is missing or could not be found.',
    tenant_network_policy_missing: 'The tenant network policy is missing or could not be found.',
    tenant_node_pool_flavor_missing: 'The tenant node pool flavor is missing or could not be found.',
    tenant_node_pool_missing: 'The tenant node pool is missing or could not be found.',
    'The user does not have permission to manage images': "You don't have permission to manage images.",
    unexpected_log_format: 'Unexpected log format.',
    unsupported_space_type: 'Unsupported space type.',
    vpn_address_missing: 'The VPN address is missing or could not be found.',
    vpn_routes_missing: 'The VPN routes is missing or could not be found.'
})

export const dialogs = Object.freeze({
    vpn_credentials_missing: {
        dialogTitle: 'Your session has ended!',
        dialogText: 'Your session has expired, please reload the page.',
        dialogAction: ['reload']
    },
    concurrency_limit_reached: {
        dialogTitle: 'Application concurrency limit reached',
        dialogText: 'Contact one of your lecturers/TAs that the concurrency limit has been exhausted in the course.',
        dialogAction: ['returnToWelcomePage'],
        primaryAction: ['returnToWelcomePage']
    },
    restoring_snapshot: {
        dialogTitle: 'Instance being reset',
        dialogText: 'An instance reset is in progress. Please wait for it to finish before continuing.',
        dialogAction: ['returnToWelcomePage'],
        primaryAction: ['returnToWelcomePage']
    },
    instance_archived: {
        dialogTitle: 'Application start failed',
        dialogText: 'The instance of this application is archived. Please reset it to a snapshot before using applications.',
        dialogAction: ['toInstanceSnapshots']
    },
    max_quota_reached: {
        dialogTitle: 'Application start failed',
        dialogText:
            'You are very near to exhaust your file storage quota, therefore the application could not be started. Please remove some files to free up space or request a quota increase via Intercom.',
        dialogAction: ['toSnapshotFiles']
    },
    user_concurrency_limit_reached: {
        dialogTitle: 'Maximum number of applications running reached!',
        dialogText: 'You have reached the maximal number of concurrent applications allowed (5). Please stop running applications before starting new ones.',
        dialogAction: ['returnToWelcomePage'],
        primaryAction: ['returnToWelcomePage']
    },
    startup_too_soon: {
        dialogTitle: 'Wrong scheduled startup time!',
        dialogText: 'Creating scheduled startup is not allowed because the selected time is in less than half an hour.',
        dialogAction: ['close']
    },
    maximum_allowed_schedules_reached: {
        dialogTitle: "Can't add new schedule!",
        dialogText: 'Your space has reached the maximum number of allowed scheduled startups (20).',
        dialogAction: ['close']
    },
    app_limit_reached: {
        dialogTitle: "Can't add new app!",
        dialogText: 'The application limit has been reached. Remove an unused application or contact your administrator.',
        dialogAction: ['close']
    },
    app_already_started: {
        dialogText: 'App already started.',
        dialogTitle: 'Application start failed',
        dialogAction: ['returnToWelcomePage'],
        primaryAction: ['returnToWelcomePage']
    },
    space_doesnt_have_tables: {
        dialogText: 'Tables feature must be enabled in the space before this application can be used.',
        dialogTitle: 'Application start failed',
        dialogAction: ['returnToWelcomePage'],
        primaryAction: ['returnToWelcomePage']
    },
    no_ncu_hours_for_contract: {
        dialogText: 'The resource pool this application belongs to, does not have enough NCU hours to start the app.',
        dialogTitle: 'Application start failed',
        dialogAction: ['contactSupport', 'returnToWelcomePage']
    }
})
